/* import __COLOCATED_TEMPLATE__ from './card.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './card.module.scss';

@classic
@classNames('card', styles.component)
export default class SharedCard extends Component {}
